<template>
  <ExpansionPanels :data="bets" :loading="loading" />
</template>
<script>
let interval;
// let firstRequest = true;
import ExpansionPanels from "@/components/my-bets/expansion-panels.vue";
import { listBetsCashout, getValuetoCashoutByBets } from "@/util/my-bets";
// import axios from "axios";
export default {
  components: {
    ExpansionPanels,
  },
  data: () => ({
    bets: [],
    loading: true,
    // listCashOutEvents: [],
    // interval: null,
  }),
  computed: {
    logged() {
      return this.$store.state.logged.status;
    },
    // maxPrice() {
    //   return this.$store.state.operators.max_prize;
    // },
  },
  mounted() {
    this.getCloseBets();
    // firstRequest = true;
  },
  beforeDestroy() {
    clearInterval(interval);
  },

  methods: {
    async getCloseBets() {
      if (this.$route.name != "liveBets" || !this.logged) return;
      try {
        this.loading = true;
        this.bets = await listBetsCashout(2);
        if (this.bets.length > 0) {
          this.bets = await getValuetoCashoutByBets(this.bets);
          var _this = this;
          var routeName = this.$route.name;
          interval = setInterval(async () => {
            if (routeName != "liveBets") return;
            _this.bets = await getValuetoCashoutByBets(_this.bets);
          }, 5000);
        }
      } catch (error) {
        const msg = this.$t("noBetsFound");
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      } finally {
        this.loading = false;
      }
    },

    // Request de eventos de apostas
    // listBetsCashout() {
    //   if (this.$route.name != "liveBets" || !this.logged) return;
    //   this.loading = true;
    //   this.$axios
    //     .post(
    //       "/player/online/betsOnline/listBetsCashout",
    //       this.$formdata({
    //         status: 2,
    //       })
    //     )
    //     .then((resp) => {
    //       this.bets = resp.data.dados.apostas;
    //     })
    //     .then(() => {
    //       this.getEventsClose();
    //     })
    //     .catch((error) => {
    //       const msg = error.response.data.messages.error;
    //       const color = "red";
    //       this.$store.commit("setNotification", { msg, color });
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    // // Request de eventos de fechamento de apostas
    // getEventsClose() {
    //   const arryBets = this.bets.map((item) => {
    //     return `${item.id}`;
    //   });

    //   var data = JSON.stringify({
    //     bets: arryBets,
    //   });

    //   let _this = this;
    //   if (firstRequest) {
    //     // Primeira requisição do getCashoutValues
    //     // Consome assim que a view é criada
    //     getCashOut();
    //     firstRequest = false;
    //   }
    //   // Atualizando os valores das odds a cada 5 segundos
    //   interval = setInterval(() => {
    //     getCashOut();
    //   }, 5000);
    //   // Atualizando os valores das odds
    //   function getCashOut() {
    //     if (_this.bets.length < 0 || _this.$route.name != "liveBets") return;

    //     const endpoint =
    //       "https://829jrp8i70.execute-api.us-east-2.amazonaws.com/pro/getValuetoCashoutByBets";

    //     const token = _this.$store.state.logged.token;
    //     const headers = {
    //       "Content-Type": "application/json",
    //       "Application-Authorization": token,
    //     };

    //     axios
    //       .post(endpoint, data, { headers: headers })
    //       .then((resp) => {
    //         let data = resp.data;
    //         const bets = _this.bets.map((bet) => {
    //           let cashOutItem = {};
    //           data.find((cashOut) => {
    //             if (cashOut.id_aposta == bet.id) {
    //               cashOutItem = cashOut;
    //             }
    //           });

    //           const CANCEL_BET_FACTOR = 0.75;

    //           if (
    //             cashOutItem &&
    //             Number(cashOutItem.valor_cancel_bet) >=
    //               Number(bet.amount) * CANCEL_BET_FACTOR &&
    //             Number(cashOutItem.valor_cancel_bet) < Number(_this.maxPrice)
    //           ) {
    //             bet.cashOutValue = cashOutItem.valor_cancel_bet;
    //           } else {
    //             bet.cashOutValue = "";
    //           }
    //           if (
    //             cashOutItem.result_bet == "0" ||
    //             cashOutItem.result_bet == "1"
    //           ) {
    //             bet.result_bet = cashOutItem.result_bet;
    //           }

    //           return bet;
    //         });
    //         _this.bets = bets;
    //       })
    //       .catch((error) => {
    //         const msg = error.response.data.messages.error;
    //         const color = "red";
    //         _this.$store.commit("setNotification", { msg, color });
    //       })
    //       .finally(() => {
    //         _this.loading = false;
    //       });
    //   }
    // },
  },
};
</script>
